export const BULLET_LIST_TYPE = 'bullet';
export const NUMBER_LIST_TYPE = 'number';
export const LETTER_LIST_TYPE = 'letter';
